<template>
  <div class="bg-gray-300" id="app">
    <div
      class="flex flex-col justify-between max-w-5xl mx-auto"
      :class="[valid === 'loading' ? 'h-screen' : '']"
      id="app"
    >
      <div id="nav" v-if="valid !== 'loading'">
        <nav-bar-iv v-if="courseTypeId == 4"></nav-bar-iv>
        <nav-bar-ekg v-else-if="courseTypeId == 3"></nav-bar-ekg>
        <nav-bar-ecg v-else-if="courseTypeId == 11"></nav-bar-ecg>
        <nav-bar v-else></nav-bar>
      </div>
      <div class="bg-white p-12" v-else></div>

      <div class="mb-auto bg-white">
        <router-view />
      </div>

      <div id="footer" v-if="valid !== 'loading'">
        <v-footer-iv v-if="courseTypeId == 4"></v-footer-iv>
        <v-footer-ekg v-else-if="courseTypeId == 3"></v-footer-ekg>
        <v-footer-ecg v-else-if="courseTypeId == 11"></v-footer-ecg>
        <v-footer v-else></v-footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
//import { hashValue } from "@/utils";

import NavBar from "@/components/Layout/NavBar.vue";
import NavBarIV from "@/components/Layout/NavBarIV.vue";
import NavBarEKG from "@/components/Layout/NavBarEKG";
import NavBarECG from "@/components/Layout/NavBarECG.vue";
import VFooter from "@/components/Layout/VFooter.vue";
import VFooterIV from "@/components/Layout/VFooterIV.vue";
import VFooterEKG from "@/components/Layout/VFooterEKG.vue";
import VFooterECG from "@/components/Layout/VFooterECG.vue";
import { watch } from "vue";

import { trackAddToCart, trackBeginCheckout, trackPurchase } from '@/store/modules/gtag';

export default {
  components: {
    NavBar,
    "nav-bar-iv": NavBarIV,
    "nav-bar-ekg": NavBarEKG,
    "nav-bar-ecg": NavBarECG,
    VFooter,
    "v-footer-iv": VFooterIV,
    "v-footer-ekg": VFooterEKG,
    "v-footer-ecg": VFooterECG,
  },
  computed: {
    ...mapState("courseInformation", ["valid", "courseTypeId", "courseType", "id", "state_fee_total", "name"]),
  },
  watch: {
    // We need to watch for the values to be populated later from the admin server
    // If we tried to grab them immediately, they would be undefined or empty
    id(newValue) {
    //  console.log("ID changed:", newValue);
    },
    name(newValue) {
      // console.log("Name changed:", newValue);
    },
    state_fee_total(newPrice) {
      // console.log("PHASE 1 GA4 EVENT HERE")
      // console.log("State fee total changed:", newPrice);
      // console.log("COURSE ID:", this.id);
      // console.log("COURSE NAME:", this.name);
      // console.log("window gtag type",typeof window.gtag);

      try {
        trackAddToCart(this.id, newPrice)

      } catch (error) {
        console.error("Error tracking add to cart:", error);
      }

      

      

    },
  },
  mounted() {
    //console.log(process.env);
    //hashValue("frfrf").then((value) => console.log(value));

    //Were going to comment this out and define gtag globally in main.js
    // window.dataLayer = window.dataLayer || [];
    // function gtag() {
    //   dataLayer.push(arguments);
    // }

      // We first use the global gtag function
      // Then we also configure gtag for google ads and google analytics

      window.gtag("js", new Date());
      // Google Ads
      window.gtag("config", "AW-1068002820");
      // Google Analytics (The new addition)
      window.gtag("config", "G-72ZQQZ9SM7", { 'debug_mode':true });
      console.log("google ads");
      if (process.env.NODE_ENV == "production") {
        window.gtag("js", new Date());
        window.gtag("config", "AW-1068002820");
        window.gtag("config", "G-72ZQQZ9SM7", { 'debug_mode':true });
        console.log("google ads production");
      }


    // console.log(this.state_fee_total);
    // console.log("id", this.id);
    console.log("mounted gtag type",typeof gtag);
    // if (typeof gtag === 'function') {
    //   console.log("gtag here");
    // } else {
    //   console.warn("gtag not defined");
    // }
  },
};
console.log("App.vue loaded");
</script>

<style src="@/assets/tailwind.css"></style>
